import { listCustomerUsers, isErpApiSuccess } from "../erpClient";
import { extractCustomerUsersArray } from "./customerUsersErpAdapter";

/** react-select props: do not open the full list on click/focus — only after typing. */
export const customerSelectMenuProps = {
  openMenuOnClick: false,
  openMenuOnFocus: false,
};

export function buildMobileSelectOptions(users, query, limit = 20) {
  const q = String(query ?? "").trim().toLowerCase();
  if (!q) return [];
  const list = Array.isArray(users) ? users : [];
  return list
    .filter((u) => String(u.mobile ?? "").toLowerCase().includes(q))
    .slice(0, limit)
    .map((user) => ({
      value: user.mobile,
      label: user.mobile,
      name: user.name,
    }));
}

export function buildNameSelectOptions(users, query, limit = 20) {
  const q = String(query ?? "").trim().toLowerCase();
  if (!q) return [];
  const list = Array.isArray(users) ? users : [];
  return list
    .filter((u) => String(u.name ?? "").toLowerCase().includes(q))
    .slice(0, limit)
    .map((user) => ({
      value: user.name,
      label: user.name,
      mobile: user.mobile,
    }));
}

/** Search customers on demand (no bulk load on page mount). */
export async function fetchCustomerUserSearch(query) {
  const q = String(query ?? "").trim();
  if (!q) return [];
  const response = await listCustomerUsers({ search: q });
  const rows = extractCustomerUsersArray(response);
  return isErpApiSuccess(response) && rows?.length ? rows : [];
}

export function toReferenceSelectOption(user) {
  const name = user.name || user.full_name || user.fullName || "";
  const mobile = user.mobile || "";
  const label = mobile ? `${name} (${mobile})` : name || String(user.id ?? "");
  return {
    value: user.id,
    label,
    name,
    mobile,
  };
}

export function buildReferenceSelectOptions(users) {
  const list = Array.isArray(users) ? users : [];
  return list.map(toReferenceSelectOption);
}
